interface FixTireImageUrl {
  (url: string, disabled?: never): string;
  (url?: string, disabled?: boolean): string | undefined;
}

export const fixTireImageUrl: FixTireImageUrl = (url, disabled) =>
  (disabled ? url : url?.replace("/model/", "/model_v2/")) as string;
